const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "krypt-49380.firebaseapp.com",
  projectId: "krypt-49380",
  storageBucket: "krypt-49380.appspot.com",
  messagingSenderId: "212793604319",
  appId: "1:212793604319:web:934fe0d7ac26d17b88516a",
};

export default firebaseConfig;
